<template>
  <div :class="`${$style.container} ${mobileLayout && $style.containerMobile}`">
    <div :class="`${$style.cell} ${$style.info}`">
      <vs-button
        :class="$style.delete"
        color="primary"
        type="flat"
        icon="delete_outline"
        @click="deleteRow"
        tabindex="-1"
        title="Удалить строку"
      />

      <div :class="$style.index">{{ index + 1 }}</div>
    </div>
    <div :class="$style.form">
      <div :class="$style.row">
        <div :class="$style.col" v-for="(col, i) in template" :key="i">
          <div v-for="cell in col" :key="cell.field" :class="`${$style.cell} ${cell.className}`">
            <elsa-v-select
              v-if="cell.type === 'select'"
              :ref="cell.field"
              v-model="model[cell.field]"
              :options="selectData[cell.dataField]"
              label="label"
              :reduce="item => item.value"
              :append-to-body="true"
              :clearable="false"
              :searchable="true"
              :html-label="cell.label"
              :danger="!!errors[cell.field]"
              :mapKeydown="selectMapKeyDown(cell.field)"
              @search:focus="onInputFocus(cell.field)"
              @search:blur="onInputBlur(cell.field)"
            />

            <elsa-v-datepicker
              v-if="cell.type === 'date'"
              :ref="cell.field"
              :label="cell.label"
              v-model="model[cell.field]"
              :danger="!!errors[cell.field]"
              :datepickerProps="cell.datepickerProps"
              @keydown="onInputKeydown($event, cell.field)"
              @focus="onInputFocus(cell.field)"
              @blur="onInputBlur(cell.field)"
              @input="onDateChange($event, cell.field)"
            />

            <elsa-v-datepicker
              v-if="cell.type === 'month'"
              :ref="cell.field"
              :label="cell.label"
              v-model="model[cell.field]"
              :danger="!!errors[cell.field]"
              view-format="MM.yyyy"
              :datepicker-props="{minimumView: 'month'}"
              @keydown="onInputKeydown($event, cell.field)"
              @focus="onInputFocus(cell.field)"
              @blur="onInputBlur(cell.field)"
              @input="onDateChange($event, cell.field)"
            />

            <vs-input
              v-if="cell.type === 'currency'"
              :ref="cell.field"
              :label="cell.label"
              v-model="model[cell.field]"
              :danger="!!errors[cell.field]"
              @input="onCurrencyChange($event, cell.field)"
              @keydown="onInputKeydown($event, cell.field)"
              @focus="onInputFocus(cell.field)"
              @blur="onInputBlur(cell.field)"
            />

            <vs-input
              v-if="cell.type === 'text'"
              :ref="cell.field"
              :label="cell.label"
              v-model="model[cell.field]"
              :danger="!!errors[cell.field]"
              @keydown="onInputKeydown($event, cell.field)"
              @focus="onInputFocus(cell.field)"
              @blur="onInputBlur(cell.field)"
            />
          </div>
        </div>
      </div>
      <div :class="$style.error" v-html="errorsText" />
    </div>
    <label v-if="asideCheckbox" :class="$style.checkPrint">
      <div :class="$style.label" v-html="asideCheckbox.label" />
      <div :class="$style.checkbox">
        <vs-checkbox
          tabindex="-1"
          v-model="model[asideCheckbox.field]"
          @change="updateValue"
          size="large"
        />
      </div>
    </label>
  </div>
</template>

<script>
import VDatepicker from 'vuejs-datepicker';

const ESC_KEY = 9;
const ENTER_KEY = 13;

const isModifiedEvent = ( e ) => e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
const isNextFieldEvent = ( e ) => !isModifiedEvent(e) && (e.keyCode === ESC_KEY || e.keyCode === ENTER_KEY);

export default {
  name:       "BulkAddRow",
  components: { VDatepicker },
  props:      ['template', 'mobileLayout', 'value', 'accounts', 'selectData', 'types', 'index', 'errors', 'asideCheckbox'],
  data() {
    return {
      model:            { ...this.value },
      selectMapKeyDown: ( fieldName ) => ( map ) => ({
        ...map,
        [ENTER_KEY]: ( e ) => {
          this.$nextTick(() => this.onInputKeydown(e, fieldName));
          return map[ENTER_KEY](e);
        },
      }),
    };
  },
  computed:   {
    inputChain() {
      return this.template.reduce(( arr, col ) => {
        col.forEach(f => arr.push(f.field));
        return arr;
      }, []);
    },
    errorsText() {
      const errors = [];
      this.template.forEach(row => {
        row.forEach(field => {
          const error = this.errors[field.field];
          if (error) errors.push(`<b>${field.label}</b>: ${error.join(', ')}`);
        });
      });
      return errors.join('<br/>');
    },
  },
  methods:    {
    focusField( fieldName ) {
      // console.log(fieldName, this.$refs);
      const $ref = this.$refs[fieldName][0];
      $ref.$el.querySelector('input').focus();
    },
    focusFirst() {
      this.focusField(this.inputChain[0]);
    },
    deleteRow() {
      this.$emit('delete');
    },
    updateValue() {
      this.$emit('input', this.model);
    },
    onInputFocus( fieldName ) {
      this.$emit('focusField', fieldName);
    },
    onInputBlur( fieldName ) {
      this.updateValue();
      this.$emit('blurField', fieldName);
    },
    onInputKeydown( e, fieldName ) {
      // console.log(e, isNextFieldEvent(e));
      const index = this.inputChain.indexOf(fieldName);
      const nextIndex = index + 1;
      if (nextIndex === 0) return;

      if (isNextFieldEvent(e)) {
        e.preventDefault();
        // Переход с последнего инпута на новую строку
        if (nextIndex >= this.inputChain.length) return this.$emit('add-row');
        // Переход на след. инпут
        this.focusField(this.inputChain[nextIndex]);
      }
    },
    onCurrencyChange( value, fieldName ) {
      if (!value) return '';

      let isNegative = false;
      if (value.charAt(0) === '-') {
        value = value.substr(1);
        isNegative = true;
      }

      value = value.replace(/[.,]/g, ".");
      const firstDotPosition = value.indexOf('.');
      value = value.replace(/[^0-9]/g, "");
      if (firstDotPosition === 0) value = '0.' + value;
      if (firstDotPosition > 0) value = value.substr(0, firstDotPosition) + "." + value.substr(firstDotPosition, 4);
      if (isNegative) value = '-' + value;

      this.model[fieldName] = value;
      return value;
    },
    onDateChange( value, fieldName ) {
      if (!value && value !== fieldName) this.updateValue();
    },
  },
  mounted() {},
  watch:      {
    value( model ) {
      this.model = { ...model };
    },
  },

};
</script>

<style lang="scss" module>
$mobile_breakpoint: 1720px;

.container {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 0 5px;
  margin: 5px 0;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    margin-top: 15px;
    left: 15px;
    right: 15px;
    height: 1px;
    background: #C8C8C8;
    display: none;
  }

  &:last-child:after {
    display: none;
  }

  :global(.vs-input) {
    width: 100%;
  }
}

.containerMobile {
  margin: 15px 0;

  &:after {
    display: block;
  }

  .row {
    flex-direction: column;
    align-items: stretch;
  }

  .cell {
    flex-grow: 1;
  }
}

.form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &:after {
    content: '';
    position: absolute;
    left: 100%;
    top: -15px;
    bottom: -15px;
    background: #C8C8C8;
    width: 1px;
  }
}

.row {
  display: flex;
  align-items: flex-start;
}

.col {
  display: flex;
  align-items: flex-start;
}

.label {
  display: block;
  padding-left: 5px;
  font-size: .85rem;
  color: rgba(var(--app-heading-color-light), 1);
}

.checkbox {
  height: 38px;
  display: flex;
  align-items: center;
}

.index {
  width: 20px;
  opacity: .6;
  text-align: right;
}

.cell {
  flex-shrink: 0;
  margin: 0 10px;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 50px;
  padding-top: 21px;
}

.delete {
  flex-shrink: 0;
  padding: 0;

  :global(.vs-icon) {
    font-size: 1.5rem;
  }
}

.checkPrint {
  position: absolute;
  padding-left: 15px;
  left: 100%;
  top: 20px;
  white-space: nowrap;

  .label {
    bottom: 100%;
    position: absolute;
  }

}

.error {
  padding: 0 10px;
  color: color(danger);
  white-space: pre-line;
  margin-top: 4px;
}
</style>
